import { Navigate, useParams, useLocation, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useCompany } from '../../contexts/CompanyContext'

function ProtectedRoute({ requireHR = false, requireAdmin = false }) {
  const { isAuthenticated, isHRAdmin, isReviewer, loading } = useAuth()
  const { loading: companyLoading, isValid } = useCompany()
  const { companySlug } = useParams()
  const location = useLocation()

  if (loading || companyLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!isValid) {
    return <Navigate to="/not-found" replace />
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${companySlug}/login`} state={{ from: location }} replace />
  }

  if (requireHR && !isHRAdmin) {
    return <Navigate to={`/${companySlug}/dashboard`} replace />
  }

  if (requireAdmin && !isReviewer) {
    return <Navigate to={`/${companySlug}/dashboard`} replace />
  }

  return <Outlet />
}

export default ProtectedRoute
